import { render } from "./MovimientosList.vue?vue&type=template&id=96746e42"
import script from "./MovimientosList.vue?vue&type=script&lang=js"
export * from "./MovimientosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__